module.exports = __webpack_public_path__ + "static/media/si.48107aeb.svg";